export const isEven = num => {
  if (num % 2 === 0) return true
  return false
}
